import React from "react";
import { Row, Col, Button, Modal, Container, Form } from "react-bootstrap";

import "./EditState.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class EditState extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: {
        name: this.props.ItemList ? this.props.ItemList.name : null,
        id: this.props.ItemList ? this.props.ItemList.id : null,
        type: this.props.ItemList ? this.props.ItemList.type : null,
        code: this.props.ItemList ? this.props.ItemList.code : null,
        capital: this.props.ItemList ? this.props.ItemList.capital : null,
        latitude: this.props.ItemList
          ? this.props.ItemList.coordinates[0]
          : null,
        longitude: this.props.ItemList
          ? this.props.ItemList.coordinates[1]
          : null
      }
    };
    this.submit = this.submit.bind(this);
    this.selectCategry = this.selectCategry.bind(this);
    this.onChangehandler = this.onChangehandler.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      value: {
        ...this.state.value,
        name: nextProps.ItemList.name,
        id: nextProps.ItemList.id,
        type: nextProps.ItemList.type && nextProps.ItemList.type,
        latitude: nextProps.ItemList && nextProps.ItemList.coordinates[0],
        longitude: nextProps.ItemList && nextProps.ItemList.coordinates[1],
        code: nextProps.ItemList && nextProps.ItemList.code,
        capital: nextProps.ItemList && nextProps.ItemList.capital
      }
    });
  }

  selectCategry = e => {
    this.setState({ value: { ...this.state.value, type: e.target.value } });
  };

  submit = () => {
    const Data = this.state.value;

    if (
      Data.latitude !== "" &&
      Data.longitude !== "" &&
      Data.name !== "" &&
      Data.code !== "" &&
      Data.capital !== ""
    ) {
      this.props.editState(Data);
      this.props.closemodel();
      this.props.resetPage();
    } else {
      toast.error("Please fill out this field", {
        autoClose: 2000,
        position: toast.POSITION.TOP_CENTER
      });
    }
  };

  onChangehandler = e => {
    const name = e.target.name;
    const value = e.target.value;
    if (name === "name") {
      this.setState({
        value: { ...this.state.value, name: value }
      });
    } else if (name === "code") {
      this.setState({ value: { ...this.state.value, code: value } });
    } else if (name === "capital") {
      this.setState({ value: { ...this.state.value, capital: value } });
    } else if (name === "latitude") {
      this.setState({ value: { ...this.state.value, latitude: value } });
    } else if (name === "longitude") {
      this.setState({ value: { ...this.state.value, longitude: value } });
    }
  };

  render() {
    return (
      <div>
        <Modal
          show={this.props.editShow}
          size="lg"
          animation={false}
          onHide={this.props.closemodel}
        >
          <Modal.Header
            style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
            closeButton
          >
            <Modal.Title>State</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Form>
                <Row>
                  <Col lg={6} md={12} sm={12} xs={12}>
                    <Container>
                      <Row>
                        <Form.Group
                          controlId="name"
                          style={{ width: "100%" }}
                        >
                          <Form.Label>Type</Form.Label>
                          <div style={{ width: "100%" }}>
                            <select style={{ width: "90%" }}

                              class="form-control"
                              onChange={this.selectCategry}
                              className="stateSelect"
                              id="type"
                              value={this.state.value.type}
                            >
                              <option value="select" defaultValue>
                                Select Type
                      </option>
                              <option value="State">State</option>
                              <option value="Union Territory">Union Territory</option>
                            </select>
                          </div>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group controlId="code" style={{ width: "90%" }}>
                          <Form.Label>Code</Form.Label>
                          <Form.Control
                            type="text"
                            name="code"
                            autoComplete="off"
                            value={this.state.value.code}
                            onChange={this.onChangehandler}
                          />
                        </Form.Group>
                      </Row>

                      <Row>
                        <Form.Group
                          controlId="latitude"
                          style={{ width: "90%" }}
                        >
                          <Form.Label>Latitude</Form.Label>
                          <Form.Control
                            type="text"
                            autoComplete="off"
                            name="latitude"
                            value={this.state.value.latitude}
                            onChange={this.onChangehandler}
                          />
                        </Form.Group>
                      </Row>
                    </Container>
                  </Col>
                  <Col lg={6} md={12} sm={12} xs={12}>
                    <Container>
                    <Row>
                        <Form.Group
                          controlId="name"
                          style={{ width: "90%" }}
                        >
                          <Form.Label>Name</Form.Label>
                          <Form.Control
                            type="text"
                            autoComplete="off"
                            name="name"
                            value={this.state.value.name}
                            onChange={this.onChangehandler}
                          />
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group controlId="capital" style={{ width: "90%" }}>
                          <Form.Label>Capital</Form.Label>
                          <Form.Control
                            type="text"
                            name="capital"
                            autoComplete="off"
                            value={this.state.value.capital}
                            onChange={this.onChangehandler}
                          />
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group controlId="longitude" style={{ width: "90%" }}>
                          <Form.Label>Longitude</Form.Label>
                          <Form.Control
                            type="text"
                            name="longitude"
                            autoComplete="off"
                            value={this.state.value.longitude}
                            onChange={this.onChangehandler}
                          />
                        </Form.Group>
                      </Row>
                    </Container>
                  </Col>
                </Row>
              </Form>
            </Container>
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}>
            <Button 
            type="submit"
            onClick={this.submit}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default EditState;
